@let dataSourceServiceValue = dataSourceService();

<ng-template
  #groupsDropdown="rtConnectedOverlay"
  rt-connected-overlay
  [hasBackdrop]="true"
  [rtConnectedOverlayAutoClose]="false"
  (backdropClick)="groupsDropdown.open = false"
>
  <rt-dropdown class="groups-dropdown">
    <view-settings-groups
      [layoutControl]="layoutControl"
      [groupControl]="groupControl"
      [defaultGroup]="dataSource().defaultGroup"
      [groups]="dataSource().groups"
      [hasBackButton]="false"
    />
  </rt-dropdown>
</ng-template>

@if (hasControls()) {
  <div class="controls">
    <div
      layout
      layout-space-between
      margin-bottom
      [attr.margin-lr]="viewLayoutType() !== 'list' ? '' : null"
    >
      @if (hasQuickFilters() || hasAdvancedFilters()) {
        <rt-views-quick-filters-container
          [hasAdvancedFilters]="hasAdvancedFilters()"
          [hasClearFilters]="true"
          margin-right-auto
        />
      }

      <rt-views-default-search [searchControl]="searchControl" margin-right-small-x />

      <rt-group variant="stacked horizontal-manual">
        <rt-view-sort [buttonClass]="hasGroupsControl() ? 'is-first' : 'is-only'" />
        @if (hasGroupsControl()) {
          <rt-icon-button
            #groupsDropdownOrigin="rtOverlayOrigin"
            [pressed]="groupsDropdown.open"
            [active]="!!configIdValue()"
            (click)="groupsDropdown.openAt(groupsDropdownOrigin)"
            variant="tertiary"
            iconName="auto-awesome-motion"
            class="is-last"
            rt-overlay-origin
          />
        }
      </rt-group>
      @if (hasLayoutPicker()) {
        <rt-views-view-layout-picker
          [formControl]="viewForm.controls.layout.controls.type"
          [layouts]="dataSource().layouts"
          [segmentedControls]="true"
          margin-left-small-x
        />
      }
    </div>
  </div>
}
@if (isEmpty() && isLoaded()) {
  <rt-views-empty-state
    [defaultEmptyState]="(dataSourceServiceValue.defaultEmptyState$ | ngrxPush)!"
    [filteredEmptyState]="(dataSourceServiceValue.filteredEmptyState$ | ngrxPush)!"
    [isViewPredefined]="isPredefinedView()"
    [filtersChanged]="filtersChanged()"
    [filtersApplied]="filtersApplied()"
    class="data-view--empty-state"
  />
} @else {
  @switch (viewLayoutType()) {
    @case ('table') {
      @defer {
        <rt-views-layout-table
          [selfScrollEnabled]="selfScrollEnabled()"
          [virtualScrollEnabled]="false"
        />
      }
    }
    @case ('list') {
      @defer {
        <rt-views-layout-list
          [selfScrollEnabled]="selfScrollEnabled()"
          [virtualScrollEnabled]="false"
        />
      }
    }
    @case ('board') {
      @defer {
        <rt-views-layout-board [cssVars]="layoutBoardCssVars" />
      }
    }
  }
}
